import { entities } from '../../../api/proto';

export default function isFreeTariff(tariff?: entities.ITariff | null): boolean {
  return !!(tariff && !tariff.price);
}